import React from "react";
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

function ResultsComponent({ results, inputData }) {
  if (!results || Object.keys(results).length === 0) {
    return <div>No results to display yet.</div>;
  }

  const activeResults = results.activeResults;

  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_number_of_circuits = activeResults?.number_of_circuits;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;

  const derating = activeResults?.Derating


  const short_circuit_cap_ok = activeResults?.shortCircuitCapacity?.ok;
  const I_conductor_new = Math.round(activeResults?.shortCircuitCapacity?.I_conductor_new * 100) / 100;
  const I_screen_new = Math.round(activeResults?.shortCircuitCapacity?.I_screen_new * 100) / 100;




  return (
<div className="App">
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh",
            padding: "1.5rem",
         }}
      >
       <Grid item xs={12} sm={12} md={12}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={2}>
              <Typography variant="h5"          
               sx={{
                fontSize: { xs: "16px", md: "20px" }, // Adjust font size for subtitle
                fontWeight: "700",
                fontFamily: "'Hubballi', sans-serif",
                letterSpacing: "1px",
            }}> 
                CALCULATION RESULTS
              </Typography>
            </Stack>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems=""
        style={{ minHeight: "10vh" }}
      >


<Grid item xs={11} sm={11} md={12}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>


     <Typography
     sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
>
  Active Cable Size: {Active_number_of_circuits} X {Active_cable_size} mm² {inputData.voltagelabel} kV {inputData.conductor}/{inputData.cabletype} Cable <br />
</Typography>
  </Stack>



  </Paper>
</Grid>


<Grid item xs={11} sm={11} md={6}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      CURRENT CARRYING CAPACITY{" "}
      <span
        style={{
          color: current_carrying_cap_ok ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({current_carrying_cap_ok ? "PASS" : "FAIL"})
      </span>
    </Typography>
  </Stack>


 <Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Current Carrying Capacity: {Circuit_capacity} A{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      Manufacturer's Datasheet (Refer Datasheet Below)
    </Typography>
  </Box>
  <br />

  Current Carrying Capacity (Derated): {Circuit_capacity_derated} A <br />
  Spare Capacity: {spare_capacity} A <br />

</Typography>
  </Paper>
</Grid>





<Grid item xs={11} sm={11} md={6}>
              <Paper
                elevation={6}
                style={{
                  padding: "1rem",
                  borderRadius: "20px",
                  background: "#ffffff",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
                }}
              >
  <Stack direction="row" alignItems="center" spacing={1} mb={2}>
    <Typography
      variant="h5"
      sx={{
        fontSize: { xs: "16px", md: "20px" },
        fontWeight: "700",
        fontFamily: "'Hubballi', sans-serif",
        letterSpacing: "1px",
      }}
    >
      SHORT CIRCUIT TEMPERATURE RISE {" "}
      <span
        style={{
          color: short_circuit_cap_ok ? "green" : "red",
          fontWeight: 700,
        }}
      >
        ({short_circuit_cap_ok ? "PASS" : "FAIL"})
      </span>
    </Typography>
  </Stack>


<Typography
  sx={{
    fontSize: { xs: "1.1rem", md: "1.1rem" },
    fontWeight: "100",
    fontFamily: "'Hubballi', sans-serif",
    letterSpacing: "1px",
    lineHeight: 2,
  }}
>
  Fault Level At Source: {inputData.faultlevel} kA <br />
  Circuit Short Circuit Capacity (Conductor) for {inputData.faulttriptime} s: {I_conductor_new} kA{" "}
    <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      Refer Calculation Sheet Below
    </Typography>
  </Box><br />
   Circuit Short Circuit Capacity (Screen) for {inputData.faulttriptime} s: {I_screen_new} kA{" "}
  <Box
    component="span"
    sx={{
      backgroundColor: "#f5f5f5",
      padding: "2px 8px",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      ml: 1,
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
    <Typography
      component="span"
      variant="body2"
      sx={{
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "0.85rem",
        color: "#333",
      }}
    >
      Refer Calculation Sheet Below
    </Typography>
  </Box>
  <br />


</Typography>
  </Paper>
</Grid>


{derating && derating.length > 0 && (
  <Grid item xs={11} sm={11} md={6}>
    <Paper
      elevation={6}
      style={{
        padding: "1rem",
        borderRadius: "20px",
        background: "#ffffff",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "700",
            fontFamily: "'Hubballi', sans-serif",
            letterSpacing: "1px",
          }}
        >
          AS3008 1.1 Derating Conditions
        </Typography>
      </Stack>

      <Typography
        sx={{
          fontSize: { xs: "1.1rem", md: "1.1rem" },
          fontWeight: "100",
          fontFamily: "'Hubballi', sans-serif",
          letterSpacing: "1px",
          lineHeight: 2,
        }}
      >
        {derating.map(([label, [value, ref]], index) => (
          <div key={index}>
            {label}: {value}{" "}
            {ref && (
              <Box
                component="span"
                sx={{
                  backgroundColor: "#f5f5f5",
                  padding: "2px 8px",
                  borderRadius: "6px",
                  display: "inline-flex",
                  alignItems: "center",
                  ml: 1,
                }}
              >
                <InfoOutlinedIcon sx={{ color: "#1976d2", fontSize: "1rem", mr: 0.5 }} />
                <Typography
                  component="span"
                  variant="body2"
                  sx={{
                    fontFamily: "'Hubballi', sans-serif",
                    fontSize: "0.85rem",
                    color: "#333",
                  }}
                >
                  {ref}
                </Typography>
              </Box>
            )}
            <br />
          </div>
        ))}
      </Typography>
    </Paper>
  </Grid>
)}




      </Grid>


          
          </Paper>
        </Grid>





      </Grid>


</div>
  );
}

export default ResultsComponent;
